module.exports = __webpack_public_path__ + "fonts/noto-sans-kr-78-300-normal.03ec245.woff2";